<template>
    <div class="lots2-Mdinput">
        <el-input
            readonly
            v-model="value"
            size="mini"
            :placeholder="config.name"
            :disabled="disabled"
            @keyup.enter.native="show"
            @change="handleChange"
            @clear="clear"
            clearable>
            <i slot="suffix" :disabled="disabled" @click="Newclear" class="el-input__icon el-icon-circle-close" v-if="value"></i>
            <el-button
                slot="append"
                icon="el-icon-search"
                class="search-btn"
                @click="show"
                :disabled="disabled"
            ></el-button>
        </el-input>
        <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
    </div>
</template>

<script>
import _ from 'lodash';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
export default {
    name: 'LotsMdInput',
    components: { advanceDialog },
    props: {
        config: Object,
        label: [String, Number],
        disabled: {
            type: Boolean,
            default: false
        },
        cascadeData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            value: ''
        };
    },
    created() {
        this.init();
        this.value = this.label;
    },
    watch: {
        label(val) {
            this.value = val;
        }
    },
    methods: {
        init() {
            // 初始化空的返回对象
            this.defaultCbObj = {};
            _.forEach(this.config.cbParams, item => {
                if (!item) return;
                const arr = item.split('#');
                this.defaultCbObj[arr.pop()] = '';
            });
        },
        show() {
            const config = this.config;
            const advanceCascade = {};
            if (_.isString(config.advanceCascade)) {
                let advanceArray = [];
                advanceArray = config.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = _.get(this.cascadeData, sourceProp, '');
                });
            }
            this.$refs.advanceDialog.show(true, config, advanceCascade, this.value);
        },
        handleChange() {
            // this.value = '';
            this.clear();
        },
        detaliSearchSure(data) {
            const prop = this.config.prop || this.config.value;
            this.value = _.get(data, prop, '');
            this.$emit('change', data);
        },
        clear() {
            this.$emit('change', this.defaultCbObj);
        },
        Newclear() {
            this.value = '';
            this.handleChange();
        }
    }
};
</script>
<style lang="less" scoped>
.lots2-Mdinput {
    .search-btn {
        padding: 12px 7px;
    }
    .el-icon-circle-close {
        cursor: pointer;
    }
}
</style>
